import videojs from "video.js";
import CopyLogsMenuItem from "./components/CopyLogsMenuItem";

const Plugin = videojs.getPlugin("plugin");

const _minSupportedIOSVersion = 9;

// Default options for the plugin.
const defaults = {};

/**
 * An advanced Video.js plugin. For more information on the API
 *
 * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
 */
class CopyLogs extends Plugin
{

	/**
	 * Create a CopyLogs plugin instance.
	 *
	 * @param  {Player} player
	 *         A Video.js Player instance.
	 *
	 * @param  {Object} [options]
	 *         An optional options object.
	 *
	 *         While not a core part of the Video.js plugin architecture, a
	 *         second argument of options is a convenient way to accept inputs
	 *         from your plugin's caller.
	 */
	constructor(player, options)
	{
		// The parent class will add player under this.player
		super(player);

		this.options = videojs.mergeOptions(defaults, options);

		// iOS 9 does not support programmatic copying of text
		const iosVersion = videojs.browser.IOS_VERSION;
		if (iosVersion === null || iosVersion > _minSupportedIOSVersion)
		{
			this.player.ready(() =>
			{
				const menu = player.controlBar.getChild("InfoButton").getChild("InfoMenu");
				menu.addItem(new CopyLogsMenuItem(player, options));
			});
		}
	}
}

// Register the plugin with video.js.
videojs.registerPlugin("infoMenuOptionCopyLogs", CopyLogs);

export default CopyLogs;
